import { Card, CardHeader, Checkbox, Divider, List } from '@mui/material'
import _ from 'lodash'
import { ReactNode, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import { TransferListContext } from './TransferListContext'
import { TransferListItem } from './types'

type CustomListProps = {
  isDisabledMaxActive?: boolean
  items: TransferListItem[]
  title: ReactNode
}

export const CustomList = ({
  isDisabledMaxActive,
  items,
  title,
}: CustomListProps): React.JSX.Element => {
  const { t } = useTranslation('components')
  const {
    areAllChecked,
    checked,
    indeterminateChecked,
    isDisabled,
    numberOfChecked,
    select,
    selectAll,
  } = useContext(TransferListContext)

  const HeaderCheckbox = (): React.JSX.Element => (
    <Checkbox
      checked={areAllChecked(items)}
      data-cy='checkbox-all'
      disabled={isDisabled || _.isEmpty(items) || isDisabledMaxActive}
      indeterminate={indeterminateChecked(items)}
      onClick={selectAll(items)}
    />
  )

  const subheader: string = t('transferList.selected', {
    all: items.length,
    interpolation: { escapeValue: false },
    selected: numberOfChecked(items),
  })

  return (
    <Card
      sx={{
        borderRadius: 0,
        minWidth: '410px',
      }}
    >
      <CardHeader
        avatar={<HeaderCheckbox />}
        subheader={subheader}
        title={title}
      />

      <Divider />

      <List
        sx={{
          height: 400,
          overflowY: 'auto',
          p: 0,
        }}
      >
        {items.map((item: TransferListItem): React.JSX.Element => {
          const { creamBackground, label, value } = item

          return (
            <ListItemButton
              creamBackground={creamBackground}
              disabled={isDisabled || isDisabledMaxActive}
              icon={
                <Checkbox
                  checked={checked.some(
                    (checkedItem: TransferListItem): boolean => checkedItem.value === value,
                  )}
                  disabled={isDisabled || isDisabledMaxActive}
                />
              }
              key={value}
              onClick={select(item)}
              sx={{
                '& p': { fontWeight: '400' },
              }}
              text={label}
              withTooltip
            />
          )
        })}
      </List>
    </Card>
  )
}
